import React, { useState } from 'react';

import clsx from 'clsx';

import { Button } from 'components/Buttons/Button';
import FormHeader from 'prequalificationV2/components/FormHeader';
import Loader from 'components/Loader';
import { ButtonType } from 'enums/ButtonType';
import { useAppDispatch } from 'prequalificationV2/hooks/useAppDispatch';
import { useAppSelector } from 'prequalificationV2/hooks/useAppSelector';
import { PreQualificationStep } from 'enums/PreQualificationStep';
import { setPreQualificationStep } from 'prequalificationV2/actions';
import { clearCoBorrower } from 'prequalificationV2/actions/coBorrower';
import { preQualificationApi } from 'prequalificationV2/api/PreQualification/PreQualificationApi';
import { useNavigateAfterUnderwriting } from 'prequalificationV2/hooks/useNavigateAfterUnderwriting';
import * as notificationManager from 'notifications/index';
import { FailureNotificationType } from 'notifications/index';

import styles from './PromptToAddCoBorrower.module.scss';

const PromptToAddCoBorrower = () => {
  const dispatch = useAppDispatch();
  const { handleUnderwritingResult } = useNavigateAfterUnderwriting();

  const { firstName } = useAppSelector((state) => state.borrower);
  const { applicationId } = useAppSelector((state) => state.application);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleDecline = async () => {
    try {
      setIsLoading(true);

      const response = await preQualificationApi.skipCoborrower(applicationId as string);

      await handleUnderwritingResult(response);
    } catch (error) {
      notificationManager.notifyFailure(FailureNotificationType.UnknownError);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddCoBorrower = () => {
    dispatch(clearCoBorrower());
    dispatch(setPreQualificationStep(PreQualificationStep.AdditionalCoBorrowerInfo));
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <FormHeader title="Consider Adding a Co-Borrower" classNameWrapper={styles.customFormHeader} />
          <div className={styles.infoContainer}>
            <div className={clsx(styles.text, styles.marginText)}>
              {firstName ? `${firstName}, we` : 'We'} are unable to prequalify you individually at this time.
            </div>
            <div className={styles.text}>Adding a co-borrower could increase your chances of:</div>
            <ul className={styles.list}>
              <li className={styles.text}>Approval</li>
              <li className={styles.text}>Lowering your Interest Rate</li>
              <li className={styles.text}>Unlocking Higher Loan Amounts</li>
            </ul>
          </div>
          <div className={styles.buttonControlContainer}>
            <Button buttonType={ButtonType.Secondary} withArrow onClick={() => handleDecline()}>
              Decline to Continue
            </Button>
            <Button onClick={() => handleAddCoBorrower()}>Continue with Co-borrower</Button>
          </div>
        </>
      )}
    </>
  );
};

export default PromptToAddCoBorrower;
